var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7 4.63353H17.25V2.31774C17.25 1.03248 16.2265 0.00195312 14.95 0.00195312H8.05C6.7735 0.00195312 5.75 1.03248 5.75 2.31774V4.63353H2.3C1.0235 4.63353 0 5.66406 0 6.94932V19.6862C0 20.9714 1.0235 22.002 2.3 22.002H20.7C21.9765 22.002 23 20.9714 23 19.6862V6.94932C23 5.66406 21.9765 4.63353 20.7 4.63353ZM8.05 2.31774H14.95V4.63353H8.05V2.31774ZM20.7 19.6862H2.3V17.3704H20.7V19.6862ZM20.7 13.8967H2.3V6.94932H5.75V9.26511H8.05V6.94932H14.95V9.26511H17.25V6.94932H20.7V13.8967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobs_icon.d95f3e74ff6eafca7252304b033f5bd6.svg";
export { ForwardRef as ReactComponent };